import Paper from '@mui/material/Paper';
import { RequestBookingListType } from '@src/types/booking';
import styled from 'styled-components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';
import Button from '@src/components/ui/atoms/button';

const Container = styled(Paper)`
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  margin-top: 20px;
  padding: 15px 20px;
  &:hover {
    background-color: #efefef;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  font-weight: 700;
`;

const Content = styled.div`
  font-weight: 600;
  font-size: 13px;
  margin-top: 15px;
  > div:first-of-type {
    margin-top: 15px;
    color: #393939;
    display: grid;
    grid-template-columns: 70% auto;
  }
`;

type PropTypes = {
  request: RequestBookingListType;
  children?: React.ReactNode;
  deleteRequest?: (id: number) => void;
};

const getTimeLabel = (timeJSON: string) => {
  const keys = JSON.parse(timeJSON);
  return `${dayjs(Object.keys(keys[0])[0]).tz('Asia/Seoul').format('YYYY-MM-DD (ddd) HH:mm')} ~ ${dayjs(
    Object.keys(keys[keys.length - 1])[0],
  )
    .add(1, 'hour')
    .tz('Asia/Seoul')
    .format('HH:mm')}`;
};

export default function RequestCard({ request, children, deleteRequest }: PropTypes) {
  const date = getTimeLabel(request.biz_item_daily_price_json);

  return (
    <Container variant="outlined" elevation={3} square={false}>
      <Header>
        <p>{request.business_name}</p>
        {deleteRequest && <Button onClick={() => deleteRequest(request.id)}>delete</Button>}
      </Header>
      <Content>
        <p>{date}</p>
        <div>
          <span>{request.item_name}</span>
          <span>{request.name}</span>
        </div>
        {children ? <div>{children}</div> : <></>}
      </Content>
    </Container>
  );
}
